import {useEffect} from 'react'
import {AssignmentCompensationCard} from '@features/assignment/components/assignment-compensation-card'
import {AssignmentHostCard} from '@features/assignment/components/assignment-host-card'
import {AssignmentHostInstructionsCard} from '@features/assignment/components/assignment-host-instructions-card'
import {AssignmentNotesCard} from '@features/assignment/components/assignment-notes-card'
import {AssignmentScheduledDate} from '@features/assignment/components/assignment-scheduled-date'
import {AssignmentShootlistCard} from '@features/assignment/components/assignment-shootlist-card'
import {Assignment} from '@features/assignment/types.ts'
import {AssignmentHostSubmissionsCard} from './assignment-host-submissions-card'
import {AssignmentOfferingCard} from './assignment-offering-card'
import {ASSIGNMENT_CARD_WRAPPER_CLASSNAME, LOCALSTORAGE_KEY_SHOOTLIST_CARD_PREFIX} from '../constants'
import {TASK_CATEGORY_REVIEW} from '@features/assignment/utils.tsx'

const experiencesCategories = ['Experiences', 'M13-Photo', 'Standard-Pro']
const serviceCategories = ['Bonus Qualifying', 'Fitness Trainer']

export const AssignmentHomesCards = ({assignment}: {assignment: Assignment}) => {
    useEffect(() => {
        // Clear the checklist stored in the local storage if the task status is 'pending_payment'
        if (assignment.task_status.status == 'pending_payment') {
            localStorage.removeItem(`${LOCALSTORAGE_KEY_SHOOTLIST_CARD_PREFIX}-${assignment.id}`)
        }
    }, [assignment.task_status.status])

    const isExperience = experiencesCategories.includes(assignment.task_category.name)
    const isService =
        assignment.task_category.name.includes('Services') || serviceCategories.includes(assignment.task_category.name)
    const isReview = assignment.task_category.name === TASK_CATEGORY_REVIEW
    const isReviewCompleted = isReview && assignment.task_status.status == 'completed'

    const showTaskCategoryCard =
        !isReview && assignment.task_status.status != 'pending_payment' && assignment.task_status.status != 'completed'

    const getCorrectTaskCategoryCard = () => {
        if (isExperience) {
            return <AssignmentHostSubmissionsCard assignment={assignment} />
        }
        if (isService) {
            return <AssignmentOfferingCard assignment={assignment} />
        }
        return <AssignmentShootlistCard assignment={assignment} />
    }
    return (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div className="flex flex-col gap-6 w-full">
                {assignment.task_status.status == 'pending_assets' && (
                    <div className={ASSIGNMENT_CARD_WRAPPER_CLASSNAME}>
                        <AssignmentScheduledDate date={assignment.to_shoot_at} />
                    </div>
                )}

                {showTaskCategoryCard
                    ? getCorrectTaskCategoryCard()
                    : !isReview && <AssignmentNotesCard assignment={assignment} />}
            </div>

            <div className="flex flex-col gap-6 w-full">
                {assignment.status == 'pending' ? (
                    !isReview && <AssignmentCompensationCard assignment={assignment} />
                ) : (
                    <>
                        {!isReviewCompleted && (
                            <>
                                <AssignmentHostCard />
                                {!!assignment.instructions && (
                                    <AssignmentHostInstructionsCard assignment={assignment} />
                                )}
                            </>
                        )}
                        {!isReview && <AssignmentCompensationCard assignment={assignment} />}

                        {showTaskCategoryCard && <AssignmentNotesCard assignment={assignment} />}
                    </>
                )}
            </div>
        </div>
    )
}
